import { Params } from '@angular/router';
import { Asset, AssetEvent, GridRequestQuery } from '@api';

export class GetAssetEvents {
    public static readonly type = '[Asset Details] Get Asset Events';

    constructor(
        public deviceId: string,
        public assetId: string,
        public gridRequestQuery: GridRequestQuery = {}
    ) {}
}

export class DeleteAsset {
    public static readonly type = '[Asset] Delete Asset';

    constructor(public force = false) {}
}

export class PushEvent {
    public static readonly type = '[Asset] Push Event';

    constructor(public data: AssetEvent[]) {}
}

export class ResetAssetDetails {
    public static readonly type = '[Asset] Reset Asset Details';
}

export class PushDeletedAsset {
    public static readonly type = '[Asset] Push deleted asset';

    constructor(public data: Asset) {}
}

export class SetTabReturnUrl {
    public static readonly type = '[Asset] Set Tab Return Url';

    constructor(
        public activeTabId: string,
        public queryParams: Params,
        public fragment?: string
    ) {}
}

export class ResetTabsReturnUrl {
    public static readonly type = '[Asset] Reset Tabs Return Url';
}
